/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
*/

import ErrorCodes from './ErrorCodes';

/**
 * Build an API error
 * @param {string} message - error message
 * @param {string} errCode - error code
 * @returns {Error} Error 
 */
export function createApiError(message, errCode) {
	const error = new Error(message);
	error.code = ErrorCodes[errCode];
	return error;
}


// WEBPACK FOOTER //
// ./src/js/api/util/ErrorUtils.js